'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobAccountCreatedModal', cobAccountCreatedModal);

	cobAccountCreatedModal.$inject = ['sessionService', '$state', 'subjectObserverMessagesService', 'observerService'];

	var sessionService,
		$state,
		subjectMessages,
		observerMessages,
		subjectObserverMessagesService,
		observerService,
		_domain;

	function cobAccountCreatedModal(_sessionService_, _$state_, _subjectObserverMessagesService_, _observerService_) {
		sessionService = _sessionService_;
		$state = _$state_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;

		return {
			restrict: 'E',
			scope: {},
			replace: false,
			templateUrl: '/app/carrier/profile/accountCreatedSuccess.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			scope.m = {};
		
			scope.onStartProfile = onStartProfile;
			document.title = 'Account Created';
			_domain = getDomain(); 

			if (_domain) {
				setBrokerBrandingByName();    
			}
		}

		function onStartProfile() {
			sessionService.redirectToLogin();
		}

		function setBrokerBrandingByName() {
			sessionService.getBrokerByDomainName(_domain)
				.then(function(response) {
					var broker = response.data;

					if (broker.imageMimeType) {
						scope.m.logoUrl = 'data:' + broker.imageMimeType + ';base64,' + broker.imageFile;
					}

					scope.m.welcomeMessage = broker.welcomeMessage;
					scope.m.brokerName = broker.brokerName;
				}); 
		}

		function getDomain() {
			return $('base').attr('href').split('/')[1];
		}
	}

})();
